import { makeAutoObservable, observable } from "mobx";
import LocalStorage from "utils/localStorage";
import { getLimitConfig } from "api/xt-fund-trans";

export const ConvertCurrencyAry = [
  { key: "usd", note: "$", maxPrecision: 2 },
  { key: "btc", note: "฿", maxPrecision: 8 },
  { key: "krw", note: "€", maxPrecision: 0 },
  { key: "inr", note: "₹", maxPrecision: 2 },
  { key: "idr", note: "Rp", maxPrecision: 2 },
  { key: "cny", note: "￥", maxPrecision: 2 },
] as const;

export type ConvertCurrencyType = typeof ConvertCurrencyAry[number]["key"];

export interface BalancesProps {
  currency: string; //币种
  currencyId?: number; //币种ID
  frozenAmount?: string; //冻结数量
  availableAmount: string; //可用数量
  totalAmount?: string; //总数量
  convertBtcAmount?: string; //总数量，折算BTC数量
  convertUsdtAmount?: string; //总数量，折算USDT数量
  withdraw?: string; //提现中（冻结）
  trade?: string; //现货委托（冻结）
  lock?: string; //锁仓（冻结）
  copyTrade?: string; //跟单（冻结）
  freeze?: string; //其他（冻结）
}

export interface BalancesLeverCurrencyProps {
  currency: string;
  currencyId: number;
  frozenAmount: string; //冻结
  availableAmount: string; //可用数量
  totalAmount: string; //总数量
  loanAmount: string; //借款数量
  capitalAmount: string; //本金数量
  interestAmount: string; //未还利息利息数量
  updatedTime: number; //更新时间，毫秒
}
export interface BalancesLeverProps {
  symbol: string;
  symbolId: number;
  btcNetAmount: string; //折算BTC净资产
  btcLoanAmount: string; //折算BTC净资产
  usdtNetAmount: string;
  usdtLoanAmount: string;
  base: BalancesLeverCurrencyProps; //卖方币，btc
  quote: BalancesLeverCurrencyProps; //买方币，usdt
}

export enum AccountEnum {
  spot = "SPOT",
  lever = "LEVER",
  futures_u = "FUTURES_U",
  futures_c = "FUTURES_C",
  finance = "FINANCE",
}

export enum AssetConverEnum {
  BTC = "BTC",
  USDT = "USDT",
}

export interface AmallAssetsCfgProps {
  btcLimit: string;
  limitAmount: string;
  limitUnit: string;
}

interface StateProps {
  convertCurrency: ConvertCurrencyType;
  isHideFund: boolean;
  assetConvert: AssetConverEnum;
  smallAssetsCfg: WithUndefined<AmallAssetsCfgProps>;
}

const balances = makeAutoObservable(
  {
    convertCurrency: "usd" as StateProps["convertCurrency"], //折算货币
    isHideFund: false as StateProps["isHideFund"], //是否隐藏资产
    assetConvert: AssetConverEnum.BTC as StateProps["assetConvert"], //显示资产d单位
    smallAssetsCfg: undefined as StateProps["smallAssetsCfg"], //小额资产配置信息
    //
    updateState(payload: Partial<StateProps>) {
      for (let va in payload) {
        this[va] = payload[va];
      }
    },
    updateConvertCurrency(currency: string) {
      const obj = ConvertCurrencyAry.find((obj) => obj.key);
      if (obj) this.convertCurrency = obj.key;
    },
    //
    initHideFund() {
      this.isHideFund = (() => {
        const isHideFund = LocalStorage.get("hideFund");
        return !!isHideFund;
      })();
    },
    initAssetConvert() {
      this.assetConvert = (() => {
        const assetConvert = LocalStorage.get("assetConvert");
        return Object.values(AssetConverEnum).includes(assetConvert) ? assetConvert : AssetConverEnum.BTC;
      })();
    },
    getSmallAssetsCfg(finallyFun?: () => void) {
      getLimitConfig()
        .then((data) => {
          this.smallAssetsCfg = data;
        })
        .finally(finallyFun);
    }, //获取小额资产配置信息
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default balances;
